export const AVAILABLE_LOCALES = ["ru", "es", "fr", "zh", "de", "en"];

export const SELECTOR_DATA = [
	{
		name: "No style",
		src: "/remove_back/magic_bg/no_style.png",
		prompt: "",
		id: 1,
	},
	{
		name: "Watercolour",
		src: "/remove_back/magic_bg/watercolor.png",
		prompt: ", watercolour!!, digital painting, concept art, smooth, sharp focus, illustration",
		id: 2,
	},
	{
		name: "Oil Painting",
		src: "/remove_back/magic_bg/oil.png",
		prompt: ", oil!! paint!!, digital painting, oilpaint, realistic art, concept art, smooth, sharp focus, illustration",
		id: 3,
	},
	{
		name: "Cartoon",
		src: "/remove_back/magic_bg/cartoon.png",
		prompt: ", pixar cartoon!! style, au naturel, PS2, PS1, hyper detailed, digital art, cinematic lighting, studio quality, smooth render, unreal engine 5 rendered, octane rendered",
		id: 4,
	},
	{
		name: "Sci-Fi",
		src: "/remove_back/magic_bg/scifi.png",
		prompt: ", sci-fi, tech stuff, glowing lights!! intricate, elegant, highly detailed, digital painting, concept art, smooth, sharp focus, illustration, artstyle by rutkowski",
		id: 5,
	},
	{
		name: "Anime",
		src: "/remove_back/magic_bg/anime.png",
		prompt: ", anime!! style, highly detailed, digital painting, concept art, sharp focus, illustration, cinematic lighting, art by Hayao Miyazaki!",
		id: 6,
	},
	{
		name: "Street Art",
		src: "/remove_back/magic_bg/street.png",
		prompt: ", graffiti!!, wallpaint, street! art, colour, concept art, sharp focus, illustration",
		id: 7,
	},
	{
		name: "Pencil Scketch",
		src: "/remove_back/magic_bg/pencil.png",
		prompt: ", pencil! sketch!, black and white, digital painting, concept art, smooth, sharp focus, illustration",
		id: 8,
	},
	{
		name: "Impressionism",
		src: "/remove_back/magic_bg/impressionism.png",
		prompt: ", impressionism!! art, digital painting, colour, concept art, blue curves in background, oil! painting, straight lines, sharp focus, smooth, illustration, art by Van Gogh!!!",
		id: 9,
	},
	{
		name: "Surrealism",
		src: "/remove_back/magic_bg/surrealism.png",
		prompt: ", surrealism!! art style, digital painting, colour, intricate, elegant, highly detailed, concept art, sharp focus, art by Salvador! Dali!",
		id: 10,
	},
	{
		name: "Cubism",
		src: "/remove_back/magic_bg/cubism.png",
		prompt: ", cubism!!, digital painting, colour, concept art, straight lines, sharp focus, illustration, art by Pablo Picasso!",
		id: 11,
	},
	{
		name: "Pop Art",
		src: "/remove_back/magic_bg/pop.png",
		prompt: ", pop art style, digital painting, dots, art by Roy Lichtenstein!!!",
		id: 12,
	},
];

export const galleryData = [
	{
		id: 0,
		animation: true,
		name: "“white dog”  sci - fi style",
		altName: "AI generated image in sci-fi style",
		src: "/remove_back/magic_bg/gallery_dog.png",
	},
	{
		id: 1,
		animation: false,
		name: "“girl with hat” oil painting style",
		altName: "AI generated image in oil painting style",
		src: "/remove_back/magic_bg/gallery_girl.png",
	},
	{
		id: 2,
		animation: false,
		name: "“field with flowers” watercolour style",
		altName: "AI generated image in watercolour style",
		src: "/remove_back/magic_bg/gallery_flowers.png",
	},
	{
		id: 3,
		animation: true,
		name: "“man with beard”  cartoon style",
		altName: "AI generated image in cartoon style",
		src: "/remove_back/magic_bg/gallery_man.png",
	},
];
